import { render } from "./SistemAyarlarView.vue?vue&type=template&id=456f3490"
import script from "./SistemAyarlarView.vue?vue&type=script&lang=js"
export * from "./SistemAyarlarView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__